import React from 'react';

import {
  footerDesktopLinksLeft,
  footerDesktopLinksMiddle,
  footerDesktopLinksRight,
} from '../../../enums/footer-links';
import {
  CopyrightBarOrganism,
  TrustpilotWidgetOrganism,
  FooterMenuOrganism,
} from '../../organisms';
import LazyLoad from 'react-lazyload';
export const FooterDesktopTemplate = () => {
  return (
    <>
      <footer className="bg-waldo-blue">
        <section className="block flex lg:flex-row flex-col max-w-screen-lg mx-auto pb-4 justify-between">
          <div className="flex lg:flex-row w-1/2">
            <div className="mt-7">
              <LazyLoad offset={100}>
                <img src="/images/icons/waldo-text.svg" />
              </LazyLoad>
            </div>
            <div className="text-white flex items-center text-center ml-7 h-16 mt-2">
              <span className="text-mobileHeader leading-16">
                Championing your vision
              </span>
            </div>
          </div>
          <div className="w-1/2 flex flex-row justify-end items-start mt-3">
            <div className="w-full block">
              <TrustpilotWidgetOrganism
                templateId="5419b6ffb0d04a076446a9af"
                styleHeight="20px"
                theme="dark"
              />
            </div>
          </div>
        </section>
        <section className="block flex lg:flex-row flex-col justify-start max-w-screen-lg mx-auto pt-6 border-t border-white">
          <div className="flex flex-col justify-between lg:w-1/2">
            <div className="mb-5 w-full flex flex-row ">
              <div className="w-full flex flex-col flex-wrap">
                <FooterMenuOrganism footerLinks={footerDesktopLinksLeft} />
              </div>
              <div className="w-full flex flex-col flex-wrap">
                <FooterMenuOrganism footerLinks={footerDesktopLinksMiddle} />
              </div>
              <div className="w-full flex flex-col flex-wrap">
                <FooterMenuOrganism footerLinks={footerDesktopLinksRight} />
              </div>
            </div>
          </div>
        </section>
      </footer>
      <CopyrightBarOrganism />
    </>
  );
};
